<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!-- <a href="http://www.ccachina.net/dhadmin" target="_blank"> 
        <span class="action"> 
          老版官网后台
        </span>
       </a> -->
      <notice-icon class="action"/>
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <!--<a-avatar class="avatar" size="small" :src="avatar()"/>-->
          <span>{{ nickname() }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">

            <a-sub-menu   key="0">
            <!-- <span slot="title"> -->
            <!-- <a-icon type="shop"/> -->
              <!-- <span> 切换单位</span></span> -->
                <!-- <a-menu-item @click="changeBusiness(b)" :key="b.id" v-for="b in [{name:'江苏省啦啦操',id:1},{name:'南京市啦啦操',id:2}]" :disabled="businessId==b.id">{{b.name}}</a-menu-item> -->
            </a-sub-menu>
<!--          <a-menu-item key="0">-->
<!--            <router-link :to="{ name: 'center' }">-->
<!--              <a-icon type="user"/>-->
<!--              <span>个人中心</span>-->
<!--            </router-link>-->
<!--          </a-menu-item>-->
            <!--<a-menu-item key="1">-->
                <!--<router-link :to="{ name: 'SiteSettingPassword' }">-->
                    <!--<a-icon type="lock"/>-->
                    <!--<span>修改密码</span>-->
                <!--</router-link>-->
            <!--</a-menu-item>-->
            <!--<a-menu-divider/>-->
          <a-menu-item key="2">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserMenu',
  components: {
    NoticeIcon
  },
    data(){
      return {
          businessId:1
      }
    },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar']),
    handleLogout () {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
          return that.Logout({}).then(() => {
            window.location.reload()
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
